/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { CreatePriceRowDto } from './CreatePriceRowDto';
import {
    CreatePriceRowDtoFromJSON,
    CreatePriceRowDtoFromJSONTyped,
    CreatePriceRowDtoToJSON,
    CreatePriceRowDtoToJSONTyped,
} from './CreatePriceRowDto';
import type { CreatePriceMode } from './CreatePriceMode';
import {
    CreatePriceModeFromJSON,
    CreatePriceModeFromJSONTyped,
    CreatePriceModeToJSON,
    CreatePriceModeToJSONTyped,
} from './CreatePriceMode';
import type { CreatePriceSessionQueryParametersDto } from './CreatePriceSessionQueryParametersDto';
import {
    CreatePriceSessionQueryParametersDtoFromJSON,
    CreatePriceSessionQueryParametersDtoFromJSONTyped,
    CreatePriceSessionQueryParametersDtoToJSON,
    CreatePriceSessionQueryParametersDtoToJSONTyped,
} from './CreatePriceSessionQueryParametersDto';

/**
 * 
 * @export
 * @interface SaveCreatePriceSessionRequest
 */
export interface SaveCreatePriceSessionRequest {
    /**
     * 
     * @type {CreatePriceMode}
     * @memberof SaveCreatePriceSessionRequest
     */
    mode: CreatePriceMode;
    /**
     * 
     * @type {CreatePriceSessionQueryParametersDto}
     * @memberof SaveCreatePriceSessionRequest
     */
    _queryParameters: CreatePriceSessionQueryParametersDto;
    /**
     * 
     * @type {Array<CreatePriceRowDto>}
     * @memberof SaveCreatePriceSessionRequest
     */
    modifiedRows: Array<CreatePriceRowDto>;
}



/**
 * Check if a given object implements the SaveCreatePriceSessionRequest interface.
 */
export function instanceOfSaveCreatePriceSessionRequest(value: object): value is SaveCreatePriceSessionRequest {
    if (!('mode' in value) || value['mode'] === undefined) return false;
    if (!('_queryParameters' in value) || value['_queryParameters'] === undefined) return false;
    if (!('modifiedRows' in value) || value['modifiedRows'] === undefined) return false;
    return true;
}

export function SaveCreatePriceSessionRequestFromJSON(json: any): SaveCreatePriceSessionRequest {
    return SaveCreatePriceSessionRequestFromJSONTyped(json, false);
}

export function SaveCreatePriceSessionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveCreatePriceSessionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'mode': CreatePriceModeFromJSON(json['mode']),
        '_queryParameters': CreatePriceSessionQueryParametersDtoFromJSON(json['queryParameters']),
        'modifiedRows': ((json['modifiedRows'] as Array<any>).map(CreatePriceRowDtoFromJSON)),
    };
}

export function SaveCreatePriceSessionRequestToJSON(json: any): SaveCreatePriceSessionRequest {
    return SaveCreatePriceSessionRequestToJSONTyped(json, false);
}

export function SaveCreatePriceSessionRequestToJSONTyped(value?: SaveCreatePriceSessionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mode': CreatePriceModeToJSON(value['mode']),
        'queryParameters': CreatePriceSessionQueryParametersDtoToJSON(value['_queryParameters']),
        'modifiedRows': ((value['modifiedRows'] as Array<any>).map(CreatePriceRowDtoToJSON)),
    };
}

